// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, browser:true, react:true*/
import React, {useContext, useEffect, useMemo} from 'react';
import cn from 'classnames';
import {Button} from '../../lib/button';
import {Modal} from '../../lib/modal';
import {Payment_form} from '../../plus/payment_form';
import {Plans_as_boxes, i_plans_as_boxes_trans}
    from '../../plus/plans_as_boxes';
import {Premium_experience, i_premium_experience}
    from '../../ui/premium_experience';
import {Br_footer} from '../../ui/browser/br_footer';
import {use_premium_page} from '../../ui/premium/use_premium_page';
import {Settings_context} from '../../settings_ctx';
// @ts-ignore
import {use_scrolled} from '/www/hola/pub/ui_utils';
import {use_translation_v} from '../../lib/trans_v';
import styles from './premium_land.module.less';
import {use_qs_with_set} from '../../lib/use_qs';
import {Svg_img} from '../../ui/svg_img';

const icons = {
    devices: <Svg_img id={'svg/feature/devices.svg'} w={40} h={40} />,
    unlim: <Svg_img id={'svg/feature/globe.svg'} w={40} h={40} />,
    globe: <Svg_img id={'svg/feature/unlim.svg'} w={40} h={40} />,
    rocket: <Svg_img id={'svg/feature/rocket.svg'} w={40} h={40} />,
    signal: <Svg_img id={'svg/feature/signal.svg'} w={40} h={40} />,
    unlock: <Svg_img id={'svg/feature/unlock.svg'} w={40} h={40} />,
};

interface i_premium_land_translations_data {
    premium_experience?: i_premium_experience;
    plans_as_boxes?: i_plans_as_boxes_trans;
}

export const Root = ({from_bext}:{from_bext:boolean})=>{
    const {theme} = useContext(Settings_context);
    const {from_bext_qs, form_ref, is_payment_form_open, opt, has_form,
        ref, plan_id, open_form, close_form, currencies, min_price_formatted,
        currency, set_plan, plans, plan, set_has_form} = use_premium_page({
            from_bext});
    const starting_at_text = `Starting at ${min_price_formatted} / month`;
    const {t} = use_translation_v({version: 0});
    const {premium_experience, plans_as_boxes} = t('premium_land',
        {returnObjects: true})||{} as i_premium_land_translations_data;
    const pe_data = useMemo<i_premium_experience>(()=>{
        return {
            ...premium_experience,
            items: premium_experience.items.map(item=>({
                ...item,
                icon: icons[item.icon_id],
            })),
        };
    }, [premium_experience]);
    const {y} = use_scrolled();
    const {qs: {with_trial}} = use_qs_with_set();
    const h = window.innerHeight || (document.documentElement ?
        document.documentElement.clientHeight : 1000);
    useEffect(()=>{
        let test_only_form = true;
        if (test_only_form)
            return;
        if (has_form)
        {
            // @ts-ignore
            window.scroll_premium_land_to_top = ()=>{
                // @ts-ignore
                window.scrollTo({
                    left: 0,
                    // @ts-ignore
                    top: form_ref.current?.offsetHeight+151,
                    behavior: 'smooth',
                });
            };
            // @ts-ignore
            if (form_ref.current?.offsetHeight <= y)
            {
                set_has_form(false);
                // @ts-ignore
                const of_h = form_ref.current?.offsetHeight;
                document.getElementById('form_id').style.display = 'none';
                // @ts-ignore
                window.scrollTo(0, y - of_h);
            }
        }
    }, [has_form, y]);
    if (from_bext_qs)
    {
        return <div className={styles.root_in_iframe} onClick={()=>{
          // @ts-ignore
          // window.parent.scroll_premium_land_to_top();
          }}><div className={cn(theme.container)}>
            <div className={styles.with_form} ref={form_ref}
            key={'form'}><Payment_form visible={is_payment_form_open}
              opt={opt} cls={styles.inline_payment_form}
              with_trial={!!with_trial}
              on_click={ev=>{
                ev.stopPropagation();
                // XXX dmitriiz: for closing all popups and selects
                document.body.click();
              }}/></div></div></div>;
    }
    return <div className={styles.root_page} style={{
      '--scrolled_to': has_form ? `${y}px` : 0,
      '--scrolled_percent': Math.floor(200*y/h) / 100,
    } as any}>
      <div className={cn(styles.float_bg_grad,
        has_form && styles.fixed_position)}></div>
      <div className={cn(styles.float_bg,
        has_form && styles.fixed_position)}></div>
      <div className={styles.relative_body}>
        {has_form && <div className={styles.float_overlay}></div>}
        {has_form && <div className={styles.float_overlay_blur}></div>}
        {has_form && <div className={styles.with_form} ref={form_ref}
          key={'form'} id={'form_id'}>
          <iframe src={`/only_payment_form?ref=${ref}&plan=${
            plan
          }&plan_id=${plan_id}${from_bext_qs ? '&holaext=1' : ''}`}/>
        </div>}
        <div className={cn(theme.container)}>
          <div className={cn(styles.first_land,
            /* has_form && styles.calc_padding*/)} key={'first_land'}>
            <h1 className={theme.logo_grey}>
            <span className={theme.primary}>Hola Premium</span> - Your
              Ticket<br/>to a Borderless Internet</h1>
            <h3>Get unlimited HD streaming and access even more global
              content!</h3>
            <Button caption={starting_at_text} arrow
              size={'lg'} cls={styles.top_btn}
              on_click={()=>{ open_form(); }}/>
          </div>
          {pe_data && <Premium_experience {...pe_data} key={'second_land'}
            open_payment_form={()=>{ open_form(); }}
            starting_at_text={starting_at_text} class_name={styles.section}/>}
          {plans && <Plans_as_boxes key={'third_land'}
            plans={plans} currencies={currencies} currency={currency}
            set_plan={set_plan} trans={plans_as_boxes||{}}
            open_payment_form={()=>{ open_form(); }}
            class_name={styles.section}/>}
          <Br_footer/>
          <Modal is_open={is_payment_form_open}
            on_close={close_form}
            paddingless width={606} on_overlay_click={()=>undefined}>
            <Payment_form visible={is_payment_form_open} opt={opt}
              cls={styles.form_in_modal} limited_height={584}/>
          </Modal>
        </div>
      </div>
    </div>;
};

Root.meta = {
    meta: {
        title: 'Subscribe to Hola Premium',
        canonical_url: 'https://hola.org/payment_land',
    },
    ssr_force: false,
    no_ssr: true,
    translation: {enabled: true, detect_by_country: true,
        white_list: ['en', 'ru', 'es']},
    opt: {
      navbar: {transparent: 1},
    },
    nosearch: true,
    headlogo: true,
};
